import React, { Suspense, useContext } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { AppContextProvider } from "./context/AppContext";
import { AuthContext, AuthProvider } from "./context/AuthContext";

import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/custom.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "react-phone-input-2/lib/style.css";
import Loader from "./components/Loader";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Auth/Home";
import SignIn from "./pages/Auth/SignIn";
import Error from "./pages/Error";

import {
  Products,
  ProductDetails,
  Variants,
  StockTracking,
  Seo,
  Masters,
  Settings,
  Category,
  CmsManagement,
  BannerManagement,
  Customer,
  SubCategory,
  KeywordEmotion,
  Diary,
  AddEditDiary,
  Occasion,
  Leadership,
  Enquiry,
  ViewEnquiry,
  Newsletter,
  FAQ,
  EmailTemplateManagement,
  EmailLogsManagement,
  LoginActivity,
  CartManagement,
  OrderManagement,
  VendorManagement,
  DigitalDocuments,
} from "./pages";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <I18nextProvider i18n={i18n}>
          <Suspense fallback={<Loader />}>
            <BrowserRouter>
              <ScrollToTop />
              <ToastContainer closeOnClick={false} />
              <AppRoutes />
            </BrowserRouter>
          </Suspense>
        </I18nextProvider>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/login" element={<SignIn />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* Auth Routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<Home />} />
        <Route exact path="/customer" element={<Customer />} />
        <Route exact path="/customer/login-activity/:userId" element={<LoginActivity />} />
        <Route exact path="/leadership" element={<Leadership />} />
        <Route exact path="/enquiry" element={<Enquiry />} />
        <Route exact path="/enquiry/:id" element={<ViewEnquiry />} />
        <Route exact path="/newsletter" element={<Newsletter />} />
        {/* category */}
        <Route exact path="/category" element={<Category />} />
        <Route exact path="/occasion" element={<Occasion />} />
        <Route exact path="/sub-category" element={<SubCategory />} />
        <Route exact path="/keyword-emotion" element={<KeywordEmotion />} />
        <Route exact path="/diary" element={<Diary />} />
        <Route exact path="/diary-add-edit" element={<AddEditDiary />} />
        <Route exact path="/diary-add-edit/:id" element={<AddEditDiary />} />

        {/* cms manager */}
        <Route exact path="/cms" element={<CmsManagement />} />
        <Route exact path="/email-template" element={<EmailTemplateManagement />} />
        <Route exact path="/email-logs" element={<EmailLogsManagement />} />
        <Route exact path="/banner" element={<BannerManagement />} />
        <Route exact path="/faq" element={<FAQ />} />

        {/* Settings */}
        <Route exact path="/setting/:slug" element={<Settings />} />
        <Route exact path="/seo" element={<Seo />} />
        {/* Masters */}
        <Route exact path="/master/:slug" element={<Masters />} />

        {/* Inventory */}
        <Route exact path="/inventory/products" element={<Products />} />
        <Route exact path="/inventory/products/:id" element={<ProductDetails />} />
        <Route exact path="/inventory/digital-documents" element={<DigitalDocuments />} />
        <Route exact path="/inventory/variants" element={<Variants />} />
        <Route exact path="/inventory/stock-tracking" element={<StockTracking />} />
        <Route exact path="/cart" element={<CartManagement />} />
        <Route exact path="/orders" element={<OrderManagement />} />
        <Route exact path="/vendors" element={<VendorManagement />} />
      </Route>

      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
